module.exports = __webpack_public_path__ + "img/pitcairn-islands.c841d7f9.png";